import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';

type BadgeSize = 'small' | 'x-small';
type BadgeVariant = 'primary' | 'secondary';

@Component({
  selector: 'bspk-badge',
  imports: [],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  host: {
    'data-bspk': 'badge',
    '[attr.data-variant]': 'variant()',
    '[attr.data-size]': 'size()',
    '[attr.data-surface-border]': 'surfaceBorder() || null',
    '[style.display]': '!count() ? "none" : null',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BspkBadge {
  readonly variant = input<BadgeVariant>('primary');
  readonly size = input<BadgeSize>('small');
  readonly surfaceBorder = input(false, { transform: booleanAttribute });
  readonly count = input<number | null>();
}
